import TrackCandidateBody from './TrackCandidateBody'
import Header from '../../components/headerAdmin/Header'
import React, {useContext } from "react";
import { UserTypeContext } from '../../AppRoute';
import UnauthorizedAccess from '../../components/UnauthorizedAccess/UnauthorizedAccess';

function TrackCandidate() {
  const { userType } = useContext(UserTypeContext);
  return (
    <>
      {((userType === "Recruiter") || (userType === "Admin") || (userType === "Recruitment Leader") || (userType === "Organization Admin") || (userType === "MIS Operator") || (userType === "Team Leader")) ?
        <>
          <div className='mainContainer_trackCandidate'>
              <Header />
              <div>
              <TrackCandidateBody />
              </div>
          </div>
        </>
        :
        <UnauthorizedAccess />
      }
    </>
  )
}

export default TrackCandidate